export default __webpack_public_path__ + "static/media/hero-map.fd758f42.png";